"use client";

import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface CollapsibleCardProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
  onToggle?: (isOpen: boolean) => void;
}

export function CollapsibleCard({
  title,
  children,
  defaultOpen = true,
  className,
  onToggle,
}: CollapsibleCardProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <Card variant="grid" className={className}>
      <CardHeader 
        className="pb-2 flex flex-row items-center justify-between space-y-0 cursor-pointer hover:bg-muted/50 transition-colors"
        onClick={() => {
          const next = !isOpen;
          setIsOpen(next);
          onToggle?.(next);
        }}
      >
        <CardTitle>{title}</CardTitle>
        <Button
          variant="ghost"
          size="sm"
          className="h-8 w-8 p-0"
        >
          {isOpen ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
          <span className="sr-only">Toggle {title}</span>
        </Button>
      </CardHeader>
      {isOpen && (
        <CardContent className="p-0">
          {children}
        </CardContent>
      )}
    </Card>
  );
}
